import { IS_CLIENT, IS_PRODUCTION } from '@repo/common-utils';

import { SendEventProperties, SendEventParams } from '../types';

export class GoogleAnalyticsService {
  private preservedEvents: SendEventParams[] = [];
  private retryCount: number = 0;
  private retryTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    this.init();
  }

  private init() {
    if (!IS_CLIENT) return;
    this.sendInitEvent();
  }

  sendEvent(eventName: string, properties?: SendEventProperties) {
    const isInitGa = window.dataLayer?.some((entry: any) => entry[0] === 'config' && typeof entry[1] === 'string' && entry[1].startsWith('G-'));

    if (typeof window.gtag !== 'function' || !isInitGa) {
      this.preservedEvents.push({ eventName, properties });
      return;
    }

    const event = eventName.replace(/[-.]/gi, '_');

    window.gtag('event', event, {
      debug_mode: !IS_PRODUCTION,
      value: properties?.amount,
      currency: properties?.amount ? 'KRW' : undefined,
      ...properties
    });
  }

  private sendInitEvent() {
    const isInitGa = window.dataLayer?.some((entry: any) => entry[0] === 'config' && typeof entry[1] === 'string' && entry[1].startsWith('G-'));

    if (typeof window.gtag === 'function' && isInitGa) {
      this.preservedEvents.forEach((event) => this.sendEvent(event.eventName, event.properties));
      this.preservedEvents = [];
      return;
    } else if (this.retryCount < 10) {
      if (this.retryTimeout) clearTimeout(this.retryTimeout);
      this.retryTimeout = setTimeout(() => {
        this.retryCount++;
        this.sendInitEvent();
      }, 500);
    }
  }
}
